import {
  constants,
  legacy_typographyStyles
} from '@newsela/angelou';

import {animationTimeout} from '../../constants';
import {tabletRange} from '../../NavMenuList/NavMenuListItem/style';
import {breakpointSwitch} from '../../style';
const {colors: {ui}} = constants;

export const popoutClassName = (globalNavHeight, pageNavMobileHeight) => ({
  display: 'grid',
  '::after': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    content: '""',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1
  },
  overflowY: 'hidden',
  gridTemplateRows: 'auto 1fr',
  gridTemplateAreas: `
      'closeOverlay'
      'childrenContainer'
  `,
  position: 'fixed',
  bottom: `${globalNavHeight + pageNavMobileHeight}px`,
  left: 0,
  height: `calc(100% - ${globalNavHeight + pageNavMobileHeight}px)`,
  width: '100%',
  [tabletRange]: {
    gridTemplateRows: '1fr 1fr',
  },
  [breakpointSwitch]: {
    '::after': {
      content: 'none'
    },
    height: 'auto',
    bottom: 'auto',
    left: 'auto',
    width: '250px',
    maxHeight: 'min(450px, calc(100vh - var(--content_offset_top)))',
    boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.2)',
    margin: '8px -20px',
    backgroundColor: 'white',
    borderRadius: '4px',
    position: 'absolute'
  }
});

export const childrenContainer = (isSearchContentDrawer) => {
  const borderRadius = isSearchContentDrawer ? '4px' : 'inherit';

  return {
    backgroundColor: ui.white['500'],
    gridArea: 'childrenContainer',
    overflow: 'auto',
    borderRadius: borderRadius,
  };
};

export const cancelButton = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  /**
   * Because the entire area is clickable
   * the focus ring around the button is hard to see.
   * We've added a border around the child text when
   * the button has focus.
   */
  '> *': {
    border: '1px rgb(255,255,255, 0) solid',
  },
  '&:focus > *': {
    border: '1px rgb(255,255,255, 1) solid',
  }
};

export const closeOverlay = {
  display: 'flex',
  justifyContent: 'flex-end',
  gridArea: 'closeOverlay',
};

export const cancelText = {
  ...legacy_typographyStyles.text2Obj,
  color: ui.white['500'],
  lineHeight: '1.5',
  fontWeight: 'bold',
  marginRight: '16px',
  textAlign: 'right'
};

export const searchDrawerStyle = {
  [tabletRange]: {
    gridTemplateRows: '1fr 3fr',
  }
};

export const appear = {
  [breakpointSwitch]: {
    transform: 'translateY(-5%)',
    opacity: 0.01,
  }
};

export const appearActive = {
  [breakpointSwitch]: {
    transition: 'all 500ms ease',
  }
};

export const enter = {
  '::after, > :nth-child(2)': {
    opacity: 0,
  },
  '> :first-child': {
    opacity: 1,
    transform: 'translateY(100%)',
  },
  [breakpointSwitch]: {
    transform: 'translateY(-5%)',
    opacity: 0.01,
    '> :first-child': {
      transform: 'none',
    },
  }
};

export const enterActive = {
  transitionTimingFunction: 'cubic-bezier(0, 1, 0.5, 1)',
  '::after, > :nth-child(2)': {
    opacity: 1,
    transition: `opacity ${animationTimeout}ms`,
  },
  '> :first-child': {
    transform: 'translateY(0%)',
    transition: `transform ${animationTimeout}ms`
  },
  [breakpointSwitch]: {
    transition: `all ${animationTimeout}ms`,
    transform: 'translateY(0%)',
    opacity: 1,
    '> :first-child': {
      transform: 'none',
    },
  }
};

export const exit = {
  '::after, > :nth-child(2)': {
    opacity: 1,
  },
  '> :first-child': {
    transform: 'translateY(0%)',
  },
  [breakpointSwitch]: {
    transform: 'translateY(0%)',
    '> :first-child': {
      transform: 'none',
    },
  }
};

export const exitActive = {
  transitionTimingFunction: 'cubic-bezier(0, 1, 0.5, 1)',
  '::after, > :nth-child(2)': {
    opacity: 0,
    transition: `opacity ${animationTimeout}ms`,
  },
  '> :first-child': {
    opacity: 1,
    transform: 'translateY(100%)',
    transition: `transform ${animationTimeout}ms`
  },
  [breakpointSwitch]: {
    transform: 'translateY(-5%)',
    transition: `all ${animationTimeout}ms ease`,
    opacity: 0.01,
    '> :first-child': {
      opacity: 1,
      transform: 'none',
    },
  }
};

